import { ChannelsName, ChannelsType } from '@/enums';
import { ChannelEntity } from '@/interfaces';
import { useGetChannel } from '@/queries';
import get from 'lodash/get';
import { useMemo } from 'react';

const channelsOrder = {
  [ChannelsName[ChannelsType.AMILI_HEALTH]]: 1,
  [ChannelsName[ChannelsType.CONSUMER_HEALTH]]: 2,
  [ChannelsName[ChannelsType.AMILI_ANALYTICS]]: 3,
  [ChannelsName[ChannelsType.RESEARCH]]: 4,
  [ChannelsName[ChannelsType.AMD]]: 5,
  [ChannelsName[ChannelsType.FMT]]: 6,
  [ChannelsName[ChannelsType.EXTERNAL]]: 7,
};

export const useGetChannels = () => {
  const query = useGetChannel();

  const originalChannels = get(query, 'data', []) as ChannelEntity[];

  const channels: ChannelEntity[] = useMemo(
    () =>
      originalChannels
        .map(channel => ({
          ...channel,
          order: channelsOrder[channel.name],
        }))
        .sort((a, b) => a.order - b.order),
    [originalChannels],
  );

  const channelIds = useMemo(
    () => channels?.map(channel => channel.id) ?? [],
    [channels],
  );

  return {
    channels,
    channelIds,
    ...query,
  };
};
